import React from 'react';
import { connect } from 'react-redux';
import { SERVICES_RESP } from '@/configurations';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import DataTable from '../DataTable/DataTable';
import TabHeader from '@/components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import { eMessageActions } from '@/actions/trading/emessage.action'
import { getSafe } from '@/helpers/global';
import { openEMessageDialog } from '@/actions/app/dialog.action'
// import { FLASH_TYPE as modalTypes } from '../../constants/app';

class EnquiryEMessage extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this)
    this.state = {
      columnDefs: [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          headerClass: 'selection-checkbox-header-center',
          cellClass: 'selection-checkbox-cell-center',
          maxWidth: 130,
          cellRenderer: (params) => {
            params.node.setSelected(params.data.checked);
          }
        },
        {
          headerName: props.language.common_time,
          colId: 'common_time',
          field: 'placeDate',
          headerClass: 'table-header table-cell',
          cellClass: 'table-cell cell-action',
          dataType: dataType.Time_CHANGE,
          maxWidth: 230,
        },
        {
          headerName: props.language.common_message,
          colId: 'common_message',
          field: 'message',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        }
      ],
      eMessage: [{id: '1', title: 'menu_EMessage'}],
      data: null,
      enableCancelBtn: false,
    }
  }

  render() {
    const { columnDefs, data, eMessage} = this.state;
    const {language} = this.props;

    return (
      <React.Fragment>
        <div className="e-message-table-container">
          <TabHeader tabs={eMessage} refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onRefresh={() => this.getData()}/>
          <div className="button">
            <button onClick={this.handleMultipleCancel}>{getSafe(() => language.common_button_delete)}</button>
          </div>
          <DataTable
            innerRef={e => this.tableRef = e}
            columnDefs={columnDefs}
            data={data} />
        </div>
      </React.Fragment>
    )
  }

  getData = () => {
    const { currentTradingAccount, language, clientID } = this.props
    const { tradingAccSeq } = currentTradingAccount;

    if (clientID) {
      if (this.tableRef) {
        this.tableRef.toggleLoadingOverlay(true);
      }
      const params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getEMessage(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ 
              data: res.result.emessageList
            })
          } else {
            this.setState({ data: [] })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.getData()
    }
    if (this.props.clientID !== prevProps.clientID) {
      this.getData();
    }
  }
  
  handleMultipleCancel = () => {
    const data = this.tableRef.gridApi.getSelectedRows();
    if(data.length > 0){
      openEMessageDialog(data,(res)=>{
        if(res){
          this.getData()
        }
      })
    }
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }
}

EnquiryEMessage.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
    isNeedRefresh: state.refresh.ipoAction
  }),
  dispatch => ({
    getEMessage: (p, res) => dispatch(eMessageActions.getEMessageAction(p, res)),
  })
)(EnquiryEMessage)
